<!--
/**
* @name: Add.vue
* @description: 直播管理-直播间详情页面
* @author: 杨波
* @create: 2020/12/01 15:16:58
* @update: 2020/12/01 15:16:58
*/
-->
<template>
  <y-view :loading="isLoading">
    <div class="form-box">
      <y-form title="基本信息" id="basic" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">销售渠道：{{ detailPara.channelCode | filterChannel(this.channelList)
          }}</y-query-item>
          <y-query-item :class="css.query_item">主播昵称：<insensitive :val="detailPara.anchorName" type="name"></insensitive></y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">直播间编码：{{ detailPara.roomCode }}</y-query-item>
          <y-query-item :class="css.query_item">主播微信号：<insensitive :val="detailPara.anchorWechat" type="name"></insensitive></y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">直播间名称：{{ detailPara.name }}</y-query-item>
          <y-query-item :class="css.query_item">封面图片：<span :class="css.preview" @click="previewImg(1)">查看</span>
          </y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">直播类型：{{ detailPara.type == "1" ? "推流设备" : "手机直播" }}</y-query-item>
          <y-query-item :class="css.query_item">分享海报： <span :class="css.preview"
                  @click="previewImg(2)">查看</span></y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">开播时间：{{ detailPara.startTime }} 结束时间：{{ detailPara.endTime
          }}</y-query-item>
          <y-query-item :class="css.query_item">直播公告： <span :class="css.preview"
                  @click="previewImg(3)">查看</span></y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">直播活动简介：{{ detailPara.introduce }}</y-query-item>
          <y-query-item :class="css.query_item">背景墙： <span :class="css.preview"
                  @click="previewImg(5)">查看</span></y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">参与方式：{{ detailPara.participateWay == "1" ? "报名参与" : "适用所有门店"
          }}</y-query-item>
          <y-query-item :class="css.query_item">开启点赞：{{ detailPara.openLike == "1" ? "开启" : "关闭" }}</y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">是否自定义订单时效：{{ detailPara.orderAutoCancelledTime ?
              `${detailPara.orderAutoCancelledTime}分钟` : "否"
          }}</y-query-item>
          <y-query-item :class="css.query_item">开启评论：{{ detailPara.openComment == "1" ? "开启" : "关闭" }}</y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">备注：{{ detailPara.remark }}</y-query-item>
          <y-query-item :class="css.query_item">开启货架：{{ detailPara.openGoods == "1" ? "开启" : "关闭" }}</y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item" v-if="detailPara.pushAddr">获取推流地址： <span @click="previewImg(4)"
                  :class="css.preview">查看</span></y-query-item>
        </y-query>
      </y-form>
      <div class="spliter" style="max-width: 97%;"></div>
      <y-form title="商品列表" id="goods" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <k-table :data="goodsList" :class="css.tableW" max-height="600px" :columns="initColumnGoods()"></k-table>
      </y-form>
      <div class="spliter" style="max-width: 97%;" v-if="detailPara.participateWay == '1'"></div>
      <y-form v-if="detailPara.participateWay == '1'" title="报名列表" id="goods" style="position: relative;"
              gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <div style="text-align: right; width: 100%; position: absolute; left: 0; top: -10px;">
          <y-button @click="onDownLoad">下载</y-button>
        </div>
        <k-table :data="signUpList" :class="css.tableW" max-height="600px" :columns="initColumnSign()"></k-table>
      </y-form>
    </div>
    <k-popup bind="v-if" layout="header,body,close,mask" title="查看详情" :show.sync="isPopupShow">
      <y-popup-body size="small">
        <y-form titleAlign="left" titleWidth="70px" contentWidth="200px">
          <span v-if="type == '4'">{{ detailPara.pushAddr }}</span>
          <img v-else :src="bigImgUrl" alt="" />
        </y-form>
      </y-popup-body>
    </k-popup>
    <k-popup bind="v-if" layout="header,body,close,mask" title="查看指定批次" :show.sync="isBatchPopupShow">
      <y-popup-body size="small">
        <y-form titleAlign="left" titleWidth="70px" contentWidth="200px">
          <div v-for="(item, index) in batchList" :key="index">{{ item }}</div>
        </y-form>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>
<script>
import { NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_DETAIL, NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST, NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_PARTICIPATE_EXPORT } from "@/assets/modules/apiList";
export default {
  data() {
    return {
      isLoading: false,
      goodsList: [],
      signUpList: [],
      isPopupShow: false,
      detailPara: {},
      bigImgUrl: "",
      batchList: [],
      isBatchPopupShow: false,
      type: "",
      channelList: [],
    };
  },
  filters: {
    filterChannel(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        if (code == a.code) {
          tmp.push(a.name);
        }
      });
      return tmp.join(",");
    },
  },
  methods: {
    initColumnGoods() {
      return [
        {
          name: "商品货号",
          field: "goodsCodeSale",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "商品名称",
          field: "name",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "直播价格",
          field: "price",
          style: {
            width: 100,
            textAlign: "center",
          },
        },

        {
          name: "是否影响佣金",
          field: "isPriceAffectProfit",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => {
            return <span class={this.css.wordStyle}>{row.isPriceAffectProfit == 1 ? '影响' : row.isPriceAffectProfit == 0 ? '不影响' : ''}</span>;
          },
        },
        {
          name: "商品链接",
          style: {
            width: 180,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
          customRender: (row) => {
            return <span class={this.css.wordStyle}>{row.url}</span>;
          },
        },
        {
          name: "指定批次",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => (
            <a
              href="javascript:;"
              onClick={(e) => {
                e.stopPropagation();
                if (row.batchNoList && row.batchNoList.length > 0) {
                  this.onViewSaleBatchList(row);
                }
              }}
            >
              {row.batchNoList && row.batchNoList.length > 0 ? "查看" : "无"}
            </a>
          ),
        },
        {
          name: "独立库存",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => <span>{row.isIndependentInventory == "1" ? row.stock : "无"}</span>,
        },
        {
          name: "限制下单数量",
          field: "limitOrderNum",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => <span>{row.limitOrderNum == 0 ? '不限制' : row.limitOrderNum}</span>,

        },
        {
          name: "限制购买件数",
          field: "limitGoodsNum",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => <span>{row.limitGoodsNum == 0 ? '不限制' : row.limitGoodsNum}</span>,

        },
      ];
    },
    initColumnSign() {
      return [
        {
          name: "门店编码",
          field: "shopCode",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "门店名称",
          field: "shopName",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "报名时间",
          field: "participateTime",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "状态",
          field: "status",
          style: {
            width: 180,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = row.status == "1" ? "已报名" : "取消报名";
            return <div>{temp}</div>;
          },
        },
      ];
    },
    //获取直播间详情
    getLiveRoomDetail(code) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_DETAIL,
        para: { roomCode: code },
      })
        .then((res) => {
          this.detailPara = res;
          this.isLoading = false;
          this.goodsList = this.detailPara.goodsSaleBroadcastDetailVOList || [];
          this.signUpList = this.detailPara.broadcastRoomParticipateVOList || [];
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    //下载报名表
    onDownLoad() {
      this.$fetch({
        api: NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_PARTICIPATE_EXPORT,
        para: {
          roomCode: this.roomCode,
        },
        isBlob: true,
        filename: "报名列表",
      })
        .then((res) => { })
        .catch(() => { });
    },
    onViewSaleBatchList(row) {
      this.isBatchPopupShow = true;
      if (row.batchNoList) {
        this.batchList = row.batchNoList.substring(1, row.batchNoList.length - 1).split(",");
      }
    },
    previewImg(type) {
      this.isPopupShow = true;
      if (type == 1) {
        this.type = 1;
        this.bigImgUrl = this.detailPara.feedsImg;
      } else if (type == 2) {
        this.type = 2;
        this.bigImgUrl = this.detailPara.downloadImg;
      } else if (type == 3) {
        this.type = 3;
        this.bigImgUrl = this.detailPara.noticeImg;
      } else if (type == 4) {
        this.type = 4;
      } else if (type == 5) {
        this.bigImgUrl = this.detailPara.coverImg;
      }
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
  },
  created() {
    const { roomCode } = this.$route.query;
    this.roomCode = roomCode;
    this.getChannelList();
    this.getLiveRoomDetail(roomCode);
  },
  beforeRouteUpdate(to, from, next) {
    const { roomCode } = to.query;
    this.roomCode = roomCode;
    this.getLiveRoomDetail(roomCode);
    next();
  },
};
</script>
<style lang="postcss" module="css">
.query {
  display: flex;
  flex-direction: row;

  &>div {
    width: 100% !important;
  }
}

.query_item {
  width: 48% !important;
}

.tableW {
  width: 100%;
}

.preview {
  cursor: pointer;
  color: rgb(24, 144, 255);
}

.wordStyle {
  word-break: break-all;
}
</style>
